module.exports = __webpack_public_path__ + "img/charger-speeds-mobile.64b8e7e4.webp";